<!-- web-view -->

<footer fxHide.xs fxHide.sm fxHide.lt-md fxLayout="column" style="bottom: 0; position: relative;">
    <div class="footer-div" fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="center center">
        <div class="details-div" fxLayout="column wrap" fxFlex="100" fxLayoutAlign="center center">
            <div>
                <div class="creatics-details" fxLayout="column" fxLayoutAlign="center center">
                    <div class="creatics-title" style="letter-spacing: 0.5px; font-weight: 600; text-align: center;">
                        {{header?.description}}
                    </div>
                    <div class="creatics-contact" fxLayoutGap="10px" style="text-align: center;">
                        <ng-container *ngFor="let item of footerList; first as isFirst; last as isLast">
                            <a [href]="item.link" (click)="trackEvent('footer_contact_us_button')">{{item.section}} </a>
                            <ng-container>/ &nbsp;</ng-container>
                        </ng-container>
                        <ng-container *ngIf="footerList?.length <= 0">
                            / &nbsp;
                        </ng-container>
                        <a href="mailto:customerservice@creatics.io">Contact Us</a>
                    </div>
                </div>
            </div>
            <br>
          
            <div>
                <p class="creatics-footer" style="text-align: center;">
                    © {{copyright}}
                </p>
            </div>
            <div class="store-buttons">
                <!-- Google Play Store Button -->
                <button (click)="onGooglePlayButton()" style="background: none;border: none;">
                    <img src="../../../../../assets/images/playstore.png" alt="Get it on Google Play" class="store-badge">
                </button>
            
                <!-- Apple App Store Button -->
                <button (click)="onAppleStoreButton()" style="background: none;border: none;">
                    <img src="../../../../../assets/images/app_store.svg" alt="Download on the App Store" class="store-badge">
                </button>
            </div>
        </div>
    </div>
    

</footer>

<!--
mobile-view -->

<footer fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>
    <div class="footer-div" fxLayout="column" style="bottom: 0;position: relative;">


        <div class="creatics-details" fxLayout="column" style="margin-left: 0 !important;">
            <p class="creatics-title mob-title">
                {{header?.description}}
            </p>
            <p class="creatics-contact" style="margin-left: 0 !important; margin-top: 1vh !important;"
                fxLayoutGap="10px">
                <ng-container *ngFor="let item of footerList; first as isFirst; last as isLast">
                    <a [href]="item.link"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'footer_'+item.section+'_button',
                    feature_context: 'FOOTER'
                    }"
                    >{{item.section}} </a> <ng-container >/
                        &nbsp; </ng-container>
                </ng-container>
                <ng-container >
                    <ng-container *ngIf="footerList?.length <= 0">/
                        &nbsp; </ng-container> <a href="mailto:customerservice@creatics.io"
                        (click)="trackEvent('footer_contact_us_button')"
                        >Contact Us</a>
                </ng-container>
            </p>
           
            <p class="creatics-footer" style="margin-left: 0 !important; margin-top: 0vh !important;">
                © {{copyright}}
            </p>
            <div class="store-buttons">
                <!-- Google Play Store Button -->
                <button  (click)="onGooglePlayButton()" style="background: none;border: none;">
                    <img src="../../../../../assets/images/playstore.png" alt="Get it on Google Play" class="store-badge">
                </button>
            
                <!-- Apple App Store Button -->
                <button (click)="onAppleStoreButton()" style="background: none;border: none;">
                    <img src="../../../../../assets/images/app_store.svg" alt="Download on the App Store" class="store-badge">
                </button>
            </div>
        </div>

    </div>


</footer>